import React from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

const DrillStatsTable = ({ drillSessionStatsData, dataLoading, selectedDrillId }) => {
    // Ensure selectedDrillId is formatted correctly
    const formattedDrillId = selectedDrillId.replace('-', '_');

    return (
        <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align={"center"}>Level</TableCell>
                        <TableCell align={"center"}>Accuracy</TableCell>
                        <TableCell align={"center"}>Avg. Dwell</TableCell>
                        <TableCell align={"center"}>Scan Frequency</TableCell>
                        <TableCell align={"center"}>Performance Ratio</TableCell>
                        <TableCell align={"center"}>Left foot shots</TableCell>
                        <TableCell align={"center"}>Right foot shots</TableCell>
                        <TableCell align={"center"}>Ball count</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!dataLoading && Array.isArray(drillSessionStatsData[formattedDrillId]) ? (
                        drillSessionStatsData[formattedDrillId].map((session) => (
                            <TableRow key={session.id}>
                                <TableCell align={"center"}>
                                    {session.level_id.includes('fam')
                                        ? 'Familiarisation'
                                        : isNaN(parseInt(session.level_id.slice(-2), 10))
                                            ? 'N/A'
                                            : `Level ${parseInt(session.level_id.slice(-2), 10)}`
                                    }
                                </TableCell>
                                <TableCell align={"center"}>
                                    {session.accuracy && !isNaN(parseFloat(session.accuracy)) ? parseFloat(session.accuracy).toFixed(2) : 'N/A'}
                                </TableCell>
                                <TableCell align={"center"}>
                                    {session.average_dwell && !isNaN(parseFloat(session.average_dwell)) ? parseFloat(session.average_dwell).toFixed(2) : 'N/A'}
                                </TableCell>
                                <TableCell align={"center"}>
                                    {session.scan_frequency && !isNaN(parseFloat(session.scan_frequency)) ? parseFloat(session.scan_frequency).toFixed(2) : 'N/A'}
                                </TableCell>
                                <TableCell align={"center"}>
                                    {session.performance_ratio && !isNaN(parseFloat(session.performance_ratio)) ? parseFloat(session.performance_ratio).toFixed(2) : 'N/A'}
                                </TableCell>
                                <TableCell align={"center"}>
                                    {session.left_foot_shots !== undefined && session.left_foot_shots !== null ? session.left_foot_shots : 'N/A'}
                                </TableCell>
                                <TableCell align={"center"}>
                                    {session.right_foot_shots !== undefined && session.right_foot_shots !== null ? session.right_foot_shots : 'N/A'}
                                </TableCell>
                                <TableCell align={"center"}>
                                    {session.ball_count !== undefined && session.ball_count !== null ? session.ball_count : 'N/A'}
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={8} align="center">
                                {dataLoading ? 'Loading data...' : 'No data available'}
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default DrillStatsTable;